// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "card-32yIf";
var _3 = "sbp-1Bwga";
export { _1 as "__esModule", _2 as "card", _3 as "sbp" }
export default { "__esModule": _1, "card": _2, "sbp": _3 }
